import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  CalendarInputComponent,
  NumberInputComponent,
  SelectInputComponent,
} from '@navstation-portal/shared/ui/components';
import { injectDispatch } from '@ngrx/signals/events';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { TIMEZONE_SELECT_OPTIONS } from '@navstation-portal/shared/util/time';

@Component({
  selector: 're-report-details',
  templateUrl: './report-details.component.html',
  imports: [
    CalendarInputComponent,
    FormsModule,
    NumberInputComponent,
    IsVisibleDirective,
    SelectInputComponent,
  ],
})
export class ReportDetailsComponent extends AbstractStoreConnectedSectionComponent {
  timezoneOptions = TIMEZONE_SELECT_OPTIONS;
  tabId = 'operational';
  sectionId = 'reportDetails';
  events = injectDispatch(offshoreOperationalEvents);
  offshoreOperationalStore = inject(OffshoreOperationalFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
